import React from 'react'
import T from 'prop-types'
import { Select } from '@mui/material'

export default function SelectScrollable({
  itemHeight = 36,
  accessoryHeight = 8,
  itemsNumber = 5.5,
  ...others
}) {
  return (
    <Select
      {...others}
      MenuProps={{
        ...others?.MenuProps,
        PaperProps: {
          ...others?.MenuProps?.PaperProps,
          sx: {
            maxHeight: itemHeight * itemsNumber + accessoryHeight,
            ...others?.MenuProps?.PaperProps?.sx,
          },
        },
      }}
    />
  )
}

SelectScrollable.propTypes = {
  itemHeight: T.number,
  accessoryHeight: T.number,
  itemsNumber: T.number,
}
